import { Center, Container, SimpleGrid, Spinner, Text } from '@chakra-ui/react';
import SelfIpoOfferingCard from 'presentation/components/modules/selfIpo/SelfIpoOfferingCard';
import AppCard from 'presentation/components/shared/card/AppCard';
import ErrorContainer from 'presentation/components/shared/ErrorContainer';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import PageLayout from 'presentation/layout/shared/page/PageLayout';
import { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import AppRoute from 'router/AppRoute';
import { useFetchSelfIpoOfferingsQuery } from 'rtkQuery/sharespro/queries/selfIpo';

const SelfIpoOfferingsPage: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data, error, isFetching, refetch } = useFetchSelfIpoOfferingsQuery();

  let content;
  let wrapByCard = true;
  if (data) {
    if (data.length > 0) {
      wrapByCard = false;
      content = (
        <SimpleGrid columns={{ base: 1, lg: 2 }} spacing="20px">
          {data.map((offering) => (
            <SelfIpoOfferingCard
              key={offering.id}
              offering={offering}
              onClick={() => navigate(AppRoute.selfIpoDetail(offering.id))}
            />
          ))}
        </SimpleGrid>
      );
    } else {
      content = <Text>{t('listIsEmpty')}</Text>;
    }
  } else if (isFetching) {
    content = <Spinner />;
  } else if (error) {
    content = (
      <ErrorContainer
        error={error}
        onRetry={() => {
          refetch();
        }}
      />
    );
  } else {
    content = <Spinner />;
  }

  if (wrapByCard) {
    content = (
      <AppCard p="20px">
        <Center>{content}</Center>
      </AppCard>
    );
  }

  return (
    <PageLayout>
      <Helmet>
        <title>{t('selfIpoTitle')}</title>
      </Helmet>
      <Container maxW="1220px" w="1220px">
        <GridHeading
          trailingLink={{
            path: AppRoute.selfIpoApplications,
            text: t('myOrdersLabel'),
            fontWeight: 700,
          }}
        >
          {t('selfIpoTitle')}
        </GridHeading>
        {content}
      </Container>
    </PageLayout>
  );
};

export default SelfIpoOfferingsPage;
